import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { MenuItem, Rating, Select, Typography } from '@mui/material';
import { Resource } from 'src/models/Skills';

interface AvailableResourcesProps {
  resources: Resource[];
  skillName: string;
}

export const AvailableResources: React.FC<AvailableResourcesProps> = ({
  resources,
  skillName
}) => {
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    width: 330,
    height: 500
  }));

  const Title = styled(Typography)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'center',
    color: '#232C68',
    fontWeight: 'bold',
    marginTop: 4
  }));

  const getTextColor = (number) => {
    switch (number) {
      case 1:
        return 'ED1C24';
      case 2:
        return '#FF7723';
      case 3:
        return '#FFC107';
      case 4:
        return '#00B26A';
      case 5:
        return '#0069E4';
      default:
        return '#fff';
    }
  };
  return (
    <Item>
      <Grid container direction={'column'}>
        <Grid
          container
          direction={'column'}
          style={{ display: 'flex', flexDirection: 'row' }}
        >
          <Grid item>
            <Title>Available Resources</Title>
          </Grid>

          <Grid item>
            <Select
              sx={{
                color: '#5B5B5B',
                fontSize: '11px',
                height: 25,
                mt: 1,
                ml: 12
              }}
              className="select-text"
              size="small"
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
              defaultValue={''}
              fullWidth={false}
              value={''}
              onChange={(e) => {}}
            >
              <MenuItem
                style={{ display: 'none' }}
                selected
                disabled
                value={''}
              >
                {'All'}
              </MenuItem>
              <MenuItem></MenuItem>
            </Select>
          </Grid>
        </Grid>

        {resources &&
          resources?.length > 0 &&
          resources.map((listItem) => {
            return (
              <Grid
                item
                style={{
                  marginTop: '.5rem',
                  marginBottom: '.5  rem',
                  marginLeft: '1rem'
                }}
                display="flex"
                alignItems="center"
              >
                <img
                  alt="logo"
                  style={{
                    objectFit: 'cover',
                    width: '48px',
                    height: '48px',
                    borderRadius: '50%',
                    marginRight: 10
                  }}
                  src={`${process.env.PUBLIC_URL}/img/user.png`}
                />
                <div>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: 11, fontWeight: 'bold', display: 'flex' }}
                  >
                    {listItem.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: 10, display: 'flex' }}
                  >
                    {listItem.designation}
                  </Typography>
                </div>
                <div
                  style={{
                    marginLeft: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'end'
                  }}
                >
                  <div
                    style={{
                      backgroundColor: '#fff',
                      border: `1px solid ${getTextColor(
                        Object.values(listItem.skills)[0]
                      )}`,
                      height: '25px',
                      borderRadius: '50%',
                      width: '25px',
                      marginRight: '20px'
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 16,
                        color: `${getTextColor(
                          Object.values(listItem.skills)[0]
                        )}`
                      }}
                    >
                      {Object.values(listItem.skills)[0]}
                    </Typography>
                  </div>
                </div>
              </Grid>
            );
          })}
      </Grid>
    </Item>
  );
};

export default AvailableResources;
